import React, { useEffect, useState } from 'react'
import { MainBox, CoursesBox, educatorCoursesSx } from '../styles'
import { Box, Button, Typography } from '@mui/material'
import { Item } from '../../Common/Item/item'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { Loader } from '../../Common/Loader/loader'
import { cleanCourseState, setCourseDetails } from '../../../Infrastructure/States/courseDetailsSlice'
import { CourseListing } from '../../CourseListing/courseListing'
import { initializeCourseSteps, resetCoursesSteps } from '../../../Infrastructure/States/coursesStepsSlice'
import paths from '../../../Infrastructure/Router/paths'

export const Courses = ({handleTabChange}) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const location = useLocation()
  const [course, setCourse] = useState('');
  const userData = useSelector((state) => state.userData.data)
  const courses = userData?.educator?.courses
  const loading = useSelector((state) => state.userData.loading)
  const coursesArray = courses ? Object.entries(courses) : [];
  const handleCreate = () => {
    dispatch(resetCoursesSteps())
    navigate(paths.createCoursePage.path)
    dispatch(cleanCourseState());
  }
  // Handle navigation and click logic
  const handleItemClick = (courseId, courseDetails) => {
    dispatch(initializeCourseSteps(courseDetails?.step))
    if (courseDetails?.status === 'in_progress') {
      dispatch(setCourseDetails({
        course: courseDetails,
        courseId
      }));
      navigate(paths.createCoursePage.path, { state: courseId });
    } else {
      setCourse({
        course: courseDetails,
        courseId
      });
      dispatch(setCourseDetails({
        course: courseDetails,
        courseId
      }));
    }
  };
  useEffect(() => {
    setCourse('');
  }, [location.pathname, location.hash])
  return (
    <MainBox>
      {course ? '' :
        <Box sx={educatorCoursesSx.headerBox}>
          <Typography variant='h1' sx={educatorCoursesSx.headerTitle}>Courses</Typography>
          <Button variant="contained" color="primary" onClick={handleCreate}>
            Create New Course
          </Button>
        </Box>}
      {
        loading ? <Loader  height={'80vh'}/> :
          course ? <CourseListing dashboardState={true} setCourse={setCourse} /> :
            coursesArray.length > 0 ?
              <CoursesBox pb={5}>
                {coursesArray.map(([courseId, courseDetails]) => (
                  <Item
                    key={courseId}
                    courseId={courseId}
                    handleTabChange={handleTabChange}
                    courseTitle={courseDetails?.courseDetails?.basics?.title}
                    courseImage={courseDetails?.courseDetails?.details?.course_image}
                    status={courseDetails?.status}
                    showSeeClassesButton={courseDetails?.status === 'active'}
                    onClick={() => handleItemClick(courseId, courseDetails)}
                  />
                ))}
              </CoursesBox> :
                <Typography sx={educatorCoursesSx.emptyText}>No courses created yet!</Typography>
        }
    </MainBox>
  )
}
